/**
 * Semantic Shadow Tokens — CSS variable references.
 */

export const shadow = {
  none: "var(--s-none)",
  sm: "var(--s-sm)",
  base: "var(--s-base)",
  md: "var(--s-md)",
  lg: "var(--s-lg)",
} as const;
